import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { EnqueuePlayerInput, EnqueuePlayerOutput, WebAppRoutes } from "types/web-app";

export const enqueuePlayer = async (
  token: string,
  input: EnqueuePlayerInput
): Promise<ServiceResponse<EnqueuePlayerOutput>> => {
  const response = await fetchWithAuth(
    `/${WebAppRoutes.ENQUEUE_PLAYER}`,
    token,
    {
      method: "POST",
      body: JSON.stringify(input),
    }
  );

  return response.json();
};

